<template>
    <div class="row g-6 g-xl-9">
        <div class="col-12 col-md-12 col-xl-12">
            <CardRh :processando="processando">
                <div class="matricula-log-sql-page">
                    <section class="filter-panel">
                        <span class="panel-border-label">Filtros</span>

                        <div class="row g-4">
                            <div class="col-12 col-md-6 col-lg-3">
                                <label for="pesquisaLogSqlMatricula" class="form-label">Pesquisar</label>
                                <input
                                    id="pesquisaLogSqlMatricula"
                                    v-model="search"
                                    @keyup="apertouEnter"
                                    type="text"
                                    class="form-control form-control-solid"
                                    placeholder="Descricao, IP, usuario ou host"
                                />
                            </div>

                            <div class="col-12 col-md-6 col-lg-2">
                                <label for="dataMinLogSqlMatricula" class="form-label">Data Minima</label>
                                <input
                                    id="dataMinLogSqlMatricula"
                                    v-model="data_min"
                                    @keyup="apertouEnter"
                                    @blur="refreshTable"
                                    type="datetime-local"
                                    class="form-control form-control-solid"
                                />
                            </div>

                            <div class="col-12 col-md-6 col-lg-2">
                                <label for="dataMaxLogSqlMatricula" class="form-label">Data Maxima</label>
                                <input
                                    id="dataMaxLogSqlMatricula"
                                    v-model="data_max"
                                    @keyup="apertouEnter"
                                    @blur="refreshTable"
                                    type="datetime-local"
                                    class="form-control form-control-solid"
                                />
                            </div>

                            <div class="col-12 col-md-6 col-lg-3" v-if="tipos">
                                <label for="tipoLogSqlMatricula" class="form-label">Tipo</label>
                                <Multiselect
                                    id="tipoLogSqlMatricula"
                                    v-model="tipo_id"
                                    :options="tipos_select"
                                    :searchable="true"
                                    @change="refreshTable"
                                />
                            </div>

                            <div class="col-12 col-lg-2 panel-actions">
                                <button type="button" class="btn btn-pmes-warning btn-sm" @click="limparFiltros">
                                    Limpar filtros
                                </button>
                            </div>
                        </div>
                    </section>

                    <section class="table-panel">
                        <KDataTable :reload="reloadDatatable" :config="config" :pesquisar="false" @tableatualizada="tableatualizada($event)">
                            <th class="text-center">Data</th>
                            <th class="text-center">Tipo</th>
                            <th class="text-center">Descricao</th>
                            <th class="text-center">Ip</th>
                            <th class="text-center">UsuarioId</th>
                            <th class="text-center">Host</th>
                        </KDataTable>
                    </section>
                </div>

                <VisualizarSql :modal="modal_visualizar" :descricao="descricaoSelecionada" />
            </CardRh>
        </div>
    </div>
</template>

<script lang="ts">
    import CardRh from "@/components/cards/ManzaCard.vue";
    import AuditoriaService from "@/service/v1/seguranca/AuditoriaService";
    import { Options, Vue } from "vue-class-component";
    import KDataTable from "@/components/datatable/newdatatable.vue";
    import { PerfilConfig } from "@/core/config/PerfisConfig";
    import SiteUtils from "@/assets/ts/aplicacao/site";
    import { namespace } from "vuex-class";
    import Multiselect from "@vueform/multiselect";
    import { Prop } from "vue-property-decorator";
    import $ from "jquery";
    import VisualizarSql from "./_VisualizarSql.vue";

    const authStore = namespace("auth");

    @Options({
        name: "LogSql",
        components: { CardRh, KDataTable, Multiselect, VisualizarSql },
    })
    export default class LogSql extends Vue {
        @authStore.Getter
        public perfis!: any;

        @Prop() readonly matricula!: any;

        public tipo_id: any = null;
        public tipos: any = null;
        public data_min: any = null;
        public data_max: any = null;
        public processando = false;
        public reloadDatatable = false;
        public config: any = null;
        public service: any = null;
        public search = "";
        public descricaoSelecionada = "";
        public modal_visualizar = "kt_visualizar_descricao_log_sql_matricula";

        public refreshTable() {
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable;
            }, 300);
        }

        public apertouEnter(e) {
            if (e.key === "Enter" || e.keyCode === 13) {
                this.refreshTable();
            }
        }

        public limparFiltros() {
            this.search = "";
            this.data_min = null;
            this.data_max = null;
            this.tipo_id = null;
            this.refreshTable();
        }

        get hasPermissao(): boolean {
            return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE], this.perfis);
        }

        get tipos_select() {
            if (this.tipos) {
                return this.tipos.map((item) => {
                    return { value: item.id, label: item.nome };
                });
            }
            return [];
        }

        public getTipo() {
            this.processando = true;
            this.service.getTipo()
                .then(response => {
                    this.tipos = JSON.parse(JSON.stringify(response));
                    this.processando = false;
                })
                .catch(() => {
                    this.processando = false;
                });
        }

        created() {
            this.config = { order: [[0, "desc"]], ajax: {}, columns: {}, columnDefs: {} };
            this.service = new AuditoriaService();
            this.getTipo();
            this.config.ajax = {
                url: this.service.getApiUrl(),
                data: (d) => {
                    const dados = {
                        Skip: d.start,
                        Take: d.length,
                        DataMin: this.data_min,
                        DataMax: this.data_max,
                        modelId: this.matricula.id,
                        model: "Matricula",
                        tipoId: this.tipo_id,
                        search: this.search || d.search.value,
                    };
                    return dados;
                }
            };

            this.config.columns = [
                { data: "createdAt", name: "createdat", searchable: false, class: "text-center" },
                { data: "tipo", name: "tipo", searchable: false, class: "text-center" },
                { data: "descricao", name: "descricao", searchable: false, class: "text-center" },
                { data: "enderecoIP", name: "enderecoip", searchable: false, class: "text-center" },
                { data: "usuarioId", name: "usuarioid", searchable: false, class: "text-center" },
                { data: "host", name: "host", searchable: false, class: "text-center" },
            ];

            this.config.columnDefs = [
                {
                    targets: 0,
                    render: (row) => {
                        return SiteUtils.formatDataHora(row);
                    }
                },
                {
                    targets: 1,
                    render: (row) => {
                        return row != null ? row.nome : "";
                    }
                },
                {
                    targets: 2,
                    render: (row) => {
                        const descricaoCodificada = encodeURIComponent(row ?? "");
                        return '<button class="btn btn-light-pmes-primary btn-sm" btn-visualizar-descricao-sql data-descricao="' + descricaoCodificada + '" data-bs-toggle="modal" data-bs-target="#' + this.modal_visualizar + '">Visualizar</button>';
                    }
                },
            ];
        }

        public tableatualizada() {
            $("[btn-visualizar-descricao-sql]").off("click").on("click", (btn) => {
                const descricaoCodificada = $(btn.currentTarget).attr("data-descricao") || "";
                this.descricaoSelecionada = descricaoCodificada ? decodeURIComponent(descricaoCodificada) : "";
            });
        }
    }
</script>

<style scoped>
    .matricula-log-sql-page {
        display: grid;
        gap: 24px;
    }

    .filter-panel,
    .table-panel {
        border: 1px solid #e5edf6;
        border-radius: 22px;
        background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
        padding: 15px;
    }

    .filter-panel {
        position: relative;
        padding-top: 24px;
    }

    .panel-border-label {
        position: absolute;
        top: -9px;
        left: 18px;
        padding: 0 10px;
        background: #ffffff;
        color: #102542;
        font-size: 0.95rem;
        font-weight: 800;
        line-height: 1.4;
    }

    .table-panel {
        padding: 2px 10px !important;
    }

    .panel-actions {
        text-align: end;
        margin-top: 20px;
    }

    .btn-sm {
        margin-left: 10px;
    }

    .registro-alteracao {
        text-align: right;
    }

    @media screen and (max-width: 991px) {
        .filter-panel,
        .table-panel {
            padding: 18px;
            border-radius: 18px;
        }

        .filter-panel {
            padding-top: 26px;
        }

        .panel-actions {
            text-align: left;
            margin-top: 0;
        }
    }
</style>
